<template>
<span>
    <i class="el-icon-search header-info-dialog-value icon-action" id="btn-unit-detail" @click="handleOpenDialog" size="mini" icon="el-icon-plus"></i>
    <el-dialog
    :close-on-click-modal="false"
    :title=" $t('outbound.units.unitDetail')"
    :visible.sync="dialogVisible"
    width="85%"
    :before-close="handleClose">
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.unitNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.unitId }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.rDate') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.shipDate }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.oDate') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.outboundDate }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.orderNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.orderNumber }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.shipper') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <el-tooltip class="item" effect="dark" :content="outboundUnits.currentDetail.shipperAccountName" placement="top">
              <span> {{ outboundUnits.currentDetail.shipperAccountName }} </span>
            </el-tooltip>
          </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.consignee') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <el-tooltip class="item" effect="dark" :content="outboundUnits.currentDetail.consigneeAccountName" placement="top">
              <span> {{ outboundUnits.currentDetail.consigneeAccountName }} </span>
            </el-tooltip>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.rWarehouse') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.warehouseCode }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.oWarehouse') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.outboundWarehouseCode }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.consolidateId') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.unitsConsolidateId }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
         <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.unitOfMeasure') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.unitOfMeasure }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.dimensions') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ dimensions(outboundUnits.currentDetail) }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.measure') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.measure }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.product') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.productCode }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.productDescription') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.productDescription }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.poNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ outboundUnits.currentDetail.po }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.farmBroker') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ outboundUnits.currentDetail.farmName }}</span>
        </el-col>
      </el-row>

      <div>
        <span class="title-list">{{ $t('outbound.units.tracking') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.status') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ statusLabel(outboundUnits.currentDetail.status,
            ((outboundUnits.currentDetail.shuttleLoad && outboundUnits.currentDetail.shuttleLoad.trim() !== ''))) }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.currentWarehouse') }}</label>
        </el-col>
        <el-col :span="4">
         <span class="span-small-list"> {{ outboundUnits.currentDetail.currentWarehouse }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.location') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <el-tooltip class="item" effect="dark" :content="outboundUnits.currentDetail.locations" placement="top-start">
              <span> {{ outboundUnits.currentDetail.locations }} </span>
            </el-tooltip>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.trailer') }}</label>
        </el-col>
        <el-col :span="4">
         <span class="span-small-list"> {{ outboundUnits.currentDetail.trailer }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.damaged') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ damagedLabel(outboundUnits.currentDetail.damaged) }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.palletCondition') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ palletStatusLabel(outboundUnits.currentDetail.palletStatus) }} </span>
        </el-col>
         <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.temperature') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.temperature }} </span>
        </el-col>
         <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.weight') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.weight }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.rPallet') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.palletCode }} </span>
        </el-col>
         <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.received') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.receivedTime }} </span>
        </el-col>
         <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.receivedBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.receivingUser }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.putAwayID') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.putAwayCode }} </span>
        </el-col>
         <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.putAway') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.putAwayTime }} </span>
        </el-col>
         <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.putAwayBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.putAwayBy }} </span>
        </el-col>
        <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.misstagedTime') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.misstagedTime }} </span>
        </el-col>
        <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('outbound.units.misstagedBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.misstagedBy }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.shuttleLoad') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.shuttleLoad }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.shuttled') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.shuttledTime }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.shuttledBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ outboundUnits.currentDetail.shuttledBy }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.coolerTime') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.coolerTime }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.coolerBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ outboundUnits.currentDetail.coolerBy }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.coolerWarehouse') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ outboundUnits.currentDetail.coolerWarehouseCode }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.loadNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.loadNumber }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.loadedTime') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.loadedTime }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.loadedBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.loadedBy }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.bolNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.bolNumber }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.shipmentNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.shipmentNumber }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.created') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.created }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.createdBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.createdBy }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.lastUpdated') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.lastUpdated }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.lastUpdatedBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.lastUpdatedBy }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.deleted') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ isDeleted(outboundUnits.currentDetail.active) }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.deletedTime') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.deletedTime }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.deletedBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.deletedBy }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.reactivatedTime') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.reactivatedTime }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.reactivatedBy') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ outboundUnits.currentDetail.reactivatedBy }} </span>
        </el-col>
      </el-row>
      <div id="outbound-unit-detail-dialog-footer" slot="footer" class="dialog-footer form-vertical-item">
      </div>
    </el-dialog>
</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import unitDataTransformLabels from '@/plugins/unitDataTransformLabels';
import constants from '@/utils/constants';
import { OUTBOUND_UNITS_SEARCH, OUTBOUND_UNITS_SEARCH_DETAIL } from '@/store/actions';

export default {
  name: 'OutboundUnitDetailDialog',
  mixins: [unitDataTransformLabels],
  computed: {
    ...mapGetters([
      'outboundUnits'
    ])
  },
  props: {
    unitEntityId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    ...mapActions({
      search: OUTBOUND_UNITS_SEARCH,
      searchDetail: OUTBOUND_UNITS_SEARCH_DETAIL,
    }),
    handleClose(done) {
      this.search({});
      done();
    },
    handleOpenDialog() {
      this.dialogVisible = true;
      this.handleSearchDetail();
    },
    async handleSearchDetail() {
      const loading = Loading.service(constants.LOADING.DEFAULT_CONFIG);
      this.searchDetail(this.unitEntityId).finally(() => loading.close());
    },
    isDeleted(active) {
      return active ? constants.STATUS_BOOLEAN.no.label : constants.STATUS_BOOLEAN.yes.label;
    }
  }
};
</script>
